import React from 'react'
import { styles } from './CouponCard.styles'
import { staticImageUrl } from '@libs/appUrl'
import { ChevronRightIcon, CouponIcon } from '@components/Icons'
import { useSelector } from 'react-redux'
import { getUserToken } from '@app-core/currentUser/selector'
import { v1PostWithToken } from '@app-core/api/v1'

function useCouponData(id) {
  const [response, setResponse] = React.useState(null)
  const userToken = useSelector(getUserToken)
  React.useEffect(() => {
    if (response) return
    v1PostWithToken('/api/gift/get', { giftID: id }, userToken).then(({ data }) =>
      setResponse(data),
    )
  }, [response, id])

  const defaultResponse = React.useRef({})
  return response || defaultResponse.current
}

export function CouponCard({ giftId, onClick = () => {}, link }) {
  const { data } = useCouponData(giftId)
  if (!data) return null

  /**
   * @param {React.SyntheticEvent} event
   */
  function handleLinkClick(event) {
    event.preventDefault()
    onClick()
  }

  return (
    <div className="wrapper">
      <div className="badge" />
      <CouponIcon className="icon" />
      <div className="layout">
        <div className="image-wrapper">
          <img src={staticImageUrl(data.img.path)} />
        </div>
        <div className="content-wrapper">
          <div className="content">
            <p className="type">波波優惠券</p>
            <p className="name line-clamp-2">{data.name}</p>
          </div>
          <a className="action" href={link} onClick={handleLinkClick}>
            前往兌換
            <ChevronRightIcon />
          </a>
        </div>
      </div>
      <style jsx>{styles}</style>
    </div>
  )
}
